import request from '@/utils/request'
import axios from 'axios'

export function painting_home_req(query) {
  return request({
    url:  '/painting/home',
    method: 'get',
    params: query,
  })
}

export function painting_page_req( data ){
  return request({
    url:  '/painting/page',
    method: 'post',
    data: data,
  })
}

export function painting_publish_req( query ){
  return request({
    url:  '/painting/publish',
    method: 'get',
    params: query,
  })
}

export function painting_history_req( data ){
  return request({
    url:  '/painting/history',
    method: 'post',
    data: data,
  })
}

export function painting_cancel_req( query ){
  return request({
    url:  '/painting/cancel',
    method: 'get',
    params: query,
  })
}

export function painting_remove_req( query ){
  return request({
    url:  '/painting/remove',
    method: 'get',
    params: query,
  })
}
 
export function painting_move_req( query ){
  return request({
    url:  '/painting/move',
    method: 'get',
    params: query,
  })
}

export function painting_detail_req( query ){
  return request({
    url:  '/painting/detail/' + query ,
    method: 'get',
    // params: query,
  })
}

export function folder_page_req( data ){
  return request({
    url:  '/folder/page',
    method: 'POST',
    data: data,
  })
}

export function folder_edit_req( data ){
  return request({
    url:  '/folder/edit',
    method: 'POST',
    data: data,
  })
}

export function folder_remove_req( query ){
  return request({
    url:  '/folder/remove',
    method: 'get',
    params: query,
  })
}
